export const guideContents = {
  "start-here": {
    title: "Bắt đầu nhanh với AutoWork",
    description:
      "Trang này giúp bạn chọn đúng chức năng trước khi thao tác. Nếu mới dùng AutoWork, hãy đọc phần này trước để tránh chọn nhầm màn hình hoặc thiếu kết nối tài khoản.",
    steps: [
      {
        title: "Bước 1: Kết nối kênh bạn muốn đăng",
        content:
          "Vào 'Tài khoản' để kết nối kênh cần dùng.\n• Đăng Facebook: kết nối Fanpage Facebook.\n• Đăng Zalo: kết nối Zalo OA.\n• Đăng website: kết nối WordPress. Nếu muốn lấy sản phẩm WooCommerce, website cần bật WooCommerce và cấp đúng thông tin kết nối.\n• Dùng affiliate: vào trang Affiliate để lấy link giới thiệu cá nhân.",
        note:
          "Nếu chưa kết nối tài khoản, nhiều nút đăng hoặc lưu cấu hình sẽ không hoạt động dù nội dung AI đã tạo xong.",
      },
      {
        title: "Bước 2: Kiểm tra gói, điểm và quyền dùng",
        content:
          "Một số chức năng phụ thuộc vào gói hoặc điểm còn lại trong tài khoản.\n• Video upload và chế độ duyệt trước thường cần gói Professional trở lên.\n• Bài website/WordPress phụ thuộc vào gói, lượt website miễn phí hoặc điểm được hệ thống cho phép.\n• Tự động bình luận và Lead Engine chỉ dùng khi tài khoản được bật tính năng tương ứng.\n• Khi không đủ điều kiện, màn hình sẽ báo lý do hoặc yêu cầu nâng cấp.",
      },
      {
        title: "Bước 3: Chọn đúng chức năng",
        content:
          "Muốn AI tự nghĩ bài theo chủ đề và đăng đều mỗi ngày: dùng 'Tự động đăng từ chủ đề'.\nMuốn đăng lần lượt nhiều ảnh/video sản phẩm: dùng 'Đăng từ ảnh/video'.\nMuốn đăng từ sản phẩm đã tạo trong AutoWork: dùng 'Đăng từ sản phẩm'.\nMuốn đăng đúng các bài bạn đã soạn sẵn: dùng 'Đăng từ bài viết có sẵn'.\nMuốn tạo một bài rồi tự duyệt và đăng ngay: dùng các màn 'Tạo bài viết AI'.",
      },
      {
        title: "Bước 4: Theo dõi sau khi lưu",
        content:
          "Sau khi lưu automation, hãy vào màn quản lý tương ứng để xem trạng thái.\n• Cấu hình chủ đề/website/WooCommerce: vào 'Quản lý tự động đăng'.\n• Cấu hình ảnh/video: vào 'Quản lý kho ảnh'.\n• Cấu hình bài viết có sẵn: vào 'Quản lý bài đăng thủ công'.\n• Sản phẩm AutoWork: vào 'Quản lý sản phẩm'.",
      },
    ],
    features: [
      {
        name: "Chọn nhanh theo nhu cầu",
        description:
          "Không cần hiểu kỹ thuật. Chỉ cần biết bạn muốn đăng từ chủ đề, ảnh/video, sản phẩm, bài viết có sẵn hay website.",
      },
      {
        name: "Tách rõ tạo bài và tự động đăng",
        description:
          "Màn 'Tạo bài viết AI' dùng để tạo một bài ngay. Các màn 'Tự động đăng' dùng để hệ thống tự chạy theo lịch.",
      },
      {
        name: "Luôn kiểm tra tài khoản kết nối",
        description:
          "Hầu hết lỗi không đăng được đến từ việc chưa chọn Fanpage/Zalo OA/WordPress hoặc tài khoản chưa đủ quyền.",
      },
    ],
    tips: [
      "Nếu chưa chắc nên dùng chức năng nào, hãy bắt đầu bằng 'Tạo bài viết AI từ chủ đề' để thử chất lượng nội dung trước.",
      "Khi chạy automation thật, nên bật chế độ duyệt trước nếu bạn muốn kiểm soát nội dung trước khi bài được đăng.",
    ],
    faqs: [
      {
        question: "Tôi nên dùng tạo bài AI hay tự động đăng?",
        answer:
          "Nếu bạn chỉ cần một bài để đăng ngay, dùng tạo bài AI. Nếu muốn hệ thống tự tạo và tự đăng theo lịch nhiều ngày, dùng các chức năng tự động đăng.",
      },
      {
        question: "Vì sao đã tạo được nội dung nhưng không đăng được?",
        answer:
          "Thường là chưa chọn tài khoản đăng, chưa kết nối Fanpage/Zalo OA/WordPress, thiếu quyền, thiếu điểm hoặc gói hiện tại chưa hỗ trợ chức năng đó.",
      },
    ],
    example: {
      scenario: "Một shop mới muốn đăng bài đều trên Facebook và Zalo.",
      input: "Đã kết nối Fanpage Facebook và Zalo OA trong trang Tài khoản.",
      config:
        "Dùng 'Tự động đăng từ chủ đề' cho bài chia sẻ hằng ngày, dùng 'Đăng từ ảnh/video' khi có lô ảnh sản phẩm mới.",
      result:
        "Shop có bài đều mỗi ngày, vẫn có thể vào màn quản lý để tạm dừng hoặc chỉnh lịch khi cần.",
    },
  },
  "auto-post": {
    title: "Tự động đăng từ chủ đề, website hoặc WooCommerce",
    description:
      "Dùng khi bạn muốn AutoWork tự tạo bài mới và đăng theo lịch. Chức năng này phù hợp cho bài chăm sóc fanpage, bài Zalo OA, bài WordPress, hoặc bài quảng bá sản phẩm WooCommerce.",
    steps: [
      {
        title: "Bước 1: Chọn nguồn nội dung",
        content:
          "Bạn có thể chọn một trong các nguồn chính.\n• Chủ đề: nhập danh sách chủ đề để AI viết bài luân phiên.\n• Website/URL: đưa đường dẫn để AI lấy ý tưởng từ nội dung có sẵn.\n• Sản phẩm WooCommerce: chọn sản phẩm từ website WooCommerce đã kết nối để AI viết bài bán hàng.\nNếu bạn muốn đăng từ sản phẩm tự tạo trong AutoWork, hãy dùng guide 'Đăng từ sản phẩm'.",
      },
      {
        title: "Bước 2: Chọn nền tảng sẽ đăng",
        content:
          "Chọn nơi bài sẽ được đăng.\n• Facebook: chọn Fanpage. Có thể dùng chế độ duyệt trước nếu tài khoản đủ điều kiện.\n• Zalo OA: chọn OA. Nội dung cần phù hợp định dạng bài Zalo, đặc biệt là ảnh đại diện bài viết.\n• WordPress: chọn website, danh mục, trạng thái đăng và các tuỳ chọn bài viết.",
      },
      {
        title: "Bước 3: Cài nội dung, ảnh và lịch",
        content:
          "Chọn phong cách, độ dài, nguồn ảnh, thông tin thương hiệu và lịch đăng. Với WooCommerce, kiểm tra sản phẩm đã có ảnh, tên, giá và mô tả rõ ràng để AI viết tốt hơn.",
      },
      {
        title: "Bước 4: Chọn cách vận hành",
        content:
          "Có hai cách chạy.\n• Đăng tự động: hệ thống tạo và đăng theo lịch.\n• Duyệt trước: hệ thống tạo bài rồi đưa vào hàng chờ để bạn xem, sửa và bấm đăng. Chế độ này đang phù hợp nhất với Facebook và tài khoản đủ gói.",
      },
      {
        title: "Bước 5: Lưu và theo dõi",
        content:
          "Sau khi lưu, vào 'Quản lý tự động đăng' để xem cấu hình, trạng thái, lịch chạy, bài chờ duyệt, bài đã đăng hoặc lỗi cần xử lý.",
      },
    ],
    features: [
      {
        name: "Dùng cho bài chạy dài ngày",
        description:
          "Phù hợp khi bạn muốn duy trì nội dung đều mỗi ngày mà không phải tự viết từng bài.",
      },
      {
        name: "Hỗ trợ nhiều nền tảng",
        description:
          "Cùng một nơi cấu hình nhưng mỗi nền tảng có phần chọn tài khoản và quy tắc đăng riêng.",
      },
      {
        name: "Có thể dùng sản phẩm WooCommerce",
        description:
          "Nếu website đã kết nối WooCommerce, AutoWork có thể lấy thông tin sản phẩm để viết bài quảng bá.",
      },
    ],
    tips: [
      "Chủ đề càng cụ thể, bài AI càng đúng ý. Ví dụ: 'mẹo chọn váy công sở cho người thấp' tốt hơn 'thời trang'.",
      "Với WordPress, nên chọn đúng danh mục và trạng thái đăng trước khi lưu để tránh bài lên sai chỗ.",
      "Nếu chưa quen, hãy dùng chế độ duyệt trước trong vài ngày đầu để kiểm tra chất lượng bài.",
    ],
    faqs: [
      {
        question: "WooCommerce nằm ở đâu?",
        answer:
          "WooCommerce nằm trong chức năng 'Tự động đăng từ chủ đề' khi bạn chọn nguồn từ sản phẩm WooCommerce. Còn 'Đăng từ sản phẩm' là sản phẩm bạn tự tạo trong AutoWork.",
      },
      {
        question: "Tôi có thể sửa bài trước khi đăng không?",
        answer:
          "Có, nếu bạn chọn chế độ duyệt trước và tài khoản đủ điều kiện. Bài sẽ nằm trong hàng chờ để bạn kiểm tra rồi mới đăng.",
      },
    ],
    example: {
      scenario: "Shop mỹ phẩm muốn mỗi ngày có một bài tư vấn da và thỉnh thoảng đẩy sản phẩm WooCommerce.",
      input: "Chủ đề: chăm sóc da dầu, chống nắng, routine ban đêm. Kết nối thêm website WooCommerce.",
      config:
        "Facebook đăng 1 bài/ngày, WordPress đăng 2 bài/tuần, bật duyệt trước cho bài Facebook.",
      result:
        "Fanpage có nội dung đều, website có bài dài hơn, sản phẩm WooCommerce được nhắc tự nhiên theo lịch.",
    },
  },
  "add-list-images": {
    title: "Tự động đăng từ danh sách ảnh hoặc video",
    description:
      "Dùng khi bạn có sẵn nhiều ảnh hoặc video và muốn hệ thống lần lượt viết caption rồi đăng theo lịch. Phù hợp cho shop có nhiều mẫu sản phẩm, ảnh feedback, ảnh kho hàng hoặc video ngắn.",
    steps: [
      {
        title: "Bước 1: Tải ảnh, video hoặc link YouTube",
        content:
          "Tải danh sách ảnh/video lên màn hình. Bạn có thể sắp xếp thứ tự để hệ thống đăng theo đúng ưu tiên. Nếu dùng video upload, tài khoản thường cần gói Professional trở lên.",
        note:
          "Không nên trộn quá nhiều loại nội dung trong một cấu hình. Nếu có cả ảnh và video, hãy tách thành các cấu hình riêng để dễ kiểm soát.",
      },
      {
        title: "Bước 2: Nhập thông tin chung",
        content:
          "Nhập tên sản phẩm, mô tả, giá, ưu đãi, địa chỉ, số điện thoại hoặc lời dặn cho AI. Thông tin này sẽ được dùng để viết caption cho từng ảnh/video.",
      },
      {
        title: "Bước 3: Chọn nơi đăng",
        content:
          "Chọn Facebook Fanpage hoặc Zalo OA đã kết nối. Với Zalo, hãy ưu tiên ảnh rõ, đúng sản phẩm và tránh ảnh quá nhỏ hoặc quá nhiều chữ.",
      },
      {
        title: "Bước 4: Chọn lịch và cách đăng",
        content:
          "Chọn lịch đăng theo tuần hoặc ngày cố định. Với Facebook và tài khoản đủ điều kiện, bạn có thể dùng chế độ duyệt trước. Nếu đăng tự động, hãy kiểm tra kỹ thông tin chung trước khi lưu.",
      },
      {
        title: "Bước 5: Theo dõi kho ảnh",
        content:
          "Sau khi lưu, vào 'Quản lý kho ảnh' để xem ảnh/video nào đã đăng, ảnh nào đang chờ, cấu hình nào đang tạm dừng hoặc cần xử lý lỗi.",
      },
    ],
    features: [
      {
        name: "Phù hợp cho nhiều mẫu sản phẩm",
        description:
          "Bạn chỉ cần nhập thông tin chung một lần, hệ thống sẽ viết caption khác nhau cho từng ảnh/video.",
      },
      {
        name: "Có thể tạo ảnh sản phẩm bằng AI",
        description:
          "Một số tài khoản có thể dùng AI để tạo hoặc biến đổi ảnh sản phẩm. Nếu chưa đủ gói, màn hình sẽ báo cần nâng cấp.",
      },
      {
        name: "Theo dõi tiến độ rõ ràng",
        description:
          "Màn quản lý kho ảnh giúp bạn biết nội dung nào đã đăng, đang chờ hoặc bị lỗi.",
      },
    ],
    tips: [
      "Ảnh càng rõ sản phẩm, caption AI càng sát thực tế.",
      "Không dựa vào first comment nếu UI của tài khoản bạn chưa hiển thị phần này.",
      "Với chiến dịch lớn, hãy tải ít ảnh chạy thử trước rồi mới thêm toàn bộ kho ảnh.",
    ],
    faqs: [
      {
        question: "Đăng hết ảnh thì sao?",
        answer:
          "Cấu hình sẽ dừng hoặc chờ bạn thêm ảnh mới, tuỳ tuỳ chọn bạn đã bật. Vào 'Quản lý kho ảnh' để thêm ảnh hoặc kiểm tra trạng thái.",
      },
      {
        question: "Tôi có thể dùng video không?",
        answer:
          "Có, nhưng video upload thường yêu cầu gói Professional trở lên. Nếu màn hình báo không đủ điều kiện, hãy kiểm tra gói hiện tại.",
      },
    ],
    example: {
      scenario: "Shop quần áo có 50 ảnh váy mới.",
      input: "Tải ảnh váy, nhập thông tin: váy hoa, đồng giá 199k, freeship, có size S-M-L.",
      config: "Đăng Facebook 3 bài/ngày, bật duyệt trước trong tuần đầu.",
      result:
        "Mỗi lần đến lịch, hệ thống chọn ảnh tiếp theo, viết caption mới và đưa vào hàng chờ hoặc đăng tự động.",
    },
  },
  "product-auto-post": {
    title: "Tự động đăng từ sản phẩm trong AutoWork",
    description:
      "Dùng khi bạn đã tạo hoặc import sản phẩm vào AutoWork và muốn hệ thống tự viết bài bán hàng theo lịch. Đây là sản phẩm nội bộ AutoWork, không phải danh sách WooCommerce.",
    steps: [
      {
        title: "Bước 1: Tạo hoặc import sản phẩm",
        content:
          "Vào 'Tạo sản phẩm' để thêm tên, giá, mô tả, ảnh và kênh bán. Sau đó vào 'Quản lý sản phẩm' để kiểm tra sản phẩm đã đúng, còn bật hoạt động và có ảnh rõ ràng.",
      },
      {
        title: "Bước 2: Mở chức năng đăng từ sản phẩm",
        content:
          "Vào 'Đăng từ sản phẩm'. Chọn nguồn sản phẩm trong AutoWork, chọn sản phẩm hoặc nhóm sản phẩm bạn muốn chạy tự động.",
      },
      {
        title: "Bước 3: Chọn nền tảng đăng",
        content:
          "Chọn Facebook Fanpage hoặc Zalo OA. Với Facebook, tài khoản đủ điều kiện có thể dùng chế độ duyệt trước. Với Zalo, hệ thống thường chạy theo kiểu đăng trực tiếp theo lịch đã đặt.",
      },
      {
        title: "Bước 4: Cài lịch và lưu",
        content:
          "Chọn ngày/giờ đăng, tần suất, cách lặp lại và yêu cầu thêm cho AI. Sau khi lưu, theo dõi trạng thái trong màn cấu hình hoặc danh sách sản phẩm.",
      },
    ],
    features: [
      {
        name: "Đúng cho sản phẩm tự quản lý trong AutoWork",
        description:
          "Bạn chủ động tạo danh sách sản phẩm, chỉnh ảnh, giá và mô tả trước khi cho hệ thống đăng.",
      },
      {
        name: "Tự viết bài bán hàng theo từng sản phẩm",
        description:
          "AI dùng tên, giá, ảnh và mô tả sản phẩm để tạo caption phù hợp hơn so với chủ đề chung.",
      },
      {
        name: "Không cần kết nối WooCommerce",
        description:
          "Nếu chỉ dùng sản phẩm nội bộ AutoWork, bạn không cần website WooCommerce.",
      },
    ],
    tips: [
      "Nếu bạn muốn lấy sản phẩm trực tiếp từ website WooCommerce, hãy dùng guide 'Tự động đăng từ chủ đề, website hoặc WooCommerce'.",
      "Trước khi chạy lịch dài ngày, hãy kiểm tra sản phẩm có ảnh, giá và mô tả đầy đủ.",
    ],
    faqs: [
      {
        question: "Khác gì với WooCommerce?",
        answer:
          "Sản phẩm AutoWork là sản phẩm bạn tạo trong app. WooCommerce là sản phẩm lấy từ website WordPress/WooCommerce và nằm trong flow auto-post khác.",
      },
      {
        question: "Tôi có cần tạo sản phẩm trước không?",
        answer:
          "Có. Nếu danh sách sản phẩm trống, hãy vào 'Tạo sản phẩm' hoặc import sản phẩm trước.",
      },
    ],
    example: {
      scenario: "Shop phụ kiện có 20 mẫu túi muốn đăng xen kẽ Facebook và Zalo.",
      input: "Tạo 20 sản phẩm trong AutoWork, mỗi sản phẩm có ảnh, giá và mô tả ngắn.",
      config: "Đăng 2 bài/ngày, Facebook dùng duyệt trước, Zalo đăng theo lịch.",
      result:
        "Hệ thống lấy từng sản phẩm để viết bài bán hàng, giúp shop không phải tự soạn caption từng mẫu.",
    },
  },
  "manual-post": {
    title: "Tự động đăng từ bài viết có sẵn",
    description:
      "Dùng khi bạn đã có sẵn nội dung và muốn AutoWork đăng đúng nội dung đó theo lịch. AI không viết lại bài, nên phù hợp với thông báo, kịch bản cố định, chương trình khuyến mãi hoặc nội dung đã được duyệt.",
    steps: [
      {
        title: "Bước 1: Đặt tên cấu hình",
        content:
          "Đặt tên dễ nhớ như 'Lịch khuyến mãi tháng 6' hoặc 'Bài chăm sóc khách cũ'. Tên này chỉ để bạn quản lý trong AutoWork.",
      },
      {
        title: "Bước 2: Thêm bài vào hàng chờ",
        content:
          "Bạn có thể nhập từng bài trực tiếp hoặc import bằng file Excel theo template. Mỗi bài nên có nội dung rõ ràng và media hợp lệ nếu cần đăng kèm ảnh/video.",
        note:
          "Với Facebook, không nên trộn ảnh và video trong cùng một bài. Mỗi bài chỉ nên có một video. Với Zalo, bài dạng article thường cần ảnh phù hợp.",
      },
      {
        title: "Bước 3: Chọn tài khoản và lịch đăng",
        content:
          "Chọn Facebook Fanpage hoặc Zalo OA, sau đó chọn ngày/giờ đăng. Có thể dùng lịch lặp theo tuần hoặc lịch theo ngày cụ thể.",
      },
      {
        title: "Bước 4: Lưu cấu hình",
        content:
          "Sau khi lưu, hệ thống sẽ đăng lần lượt bài trong hàng chờ. Nếu bật lặp lại, hệ thống có thể quay lại từ đầu khi đã đăng hết danh sách.",
      },
      {
        title: "Bước 5: Quản lý sau khi chạy",
        content:
          "Vào 'Quản lý bài đăng thủ công' để xem bài chờ, bài đã đăng, cấu hình bị tạm dừng, hoặc chỉnh sửa nội dung chưa đăng.",
      },
    ],
    features: [
      {
        name: "Không bị AI sửa nội dung",
        description:
          "Hệ thống đăng đúng nội dung bạn đã chuẩn bị, phù hợp với nội dung cần kiểm duyệt kỹ.",
      },
      {
        name: "Import Excel",
        description:
          "Phù hợp khi bạn có nhiều bài viết, muốn nhập nhanh thay vì copy từng bài.",
      },
      {
        name: "Có hàng chờ rõ ràng",
        description:
          "Bạn biết bài nào đang chờ, bài nào đã đăng và bài nào cần sửa.",
      },
    ],
    tips: [
      "Dùng chức năng này nếu nội dung đã có sẵn và bạn chỉ cần hệ thống đăng đúng giờ.",
      "Đặt tên cấu hình theo chiến dịch để sau này dễ tìm và tạm dừng.",
    ],
    faqs: [
      {
        question: "Tôi có thể sửa bài đang chờ không?",
        answer:
          "Có. Vào 'Quản lý bài đăng thủ công' để sửa hoặc xoá bài chưa đăng.",
      },
      {
        question: "Chức năng này có dùng AI viết lại không?",
        answer:
          "Không. Đây là flow đăng bài có sẵn. Nếu muốn AI viết nội dung, hãy dùng các màn tạo bài AI hoặc tự động đăng từ chủ đề.",
      },
    ],
    example: {
      scenario: "Trung tâm tiếng Anh có 30 bài từ vựng đã soạn sẵn.",
      input: "Import Excel gồm nội dung bài và link ảnh.",
      config: "Đăng mỗi ngày lúc 6:00, bật lặp lại hàng chờ.",
      result:
        "Mỗi sáng hệ thống đăng đúng bài đã chuẩn bị, không cần nhân sự trực.",
    },
  },
  "normal-post": {
    title: "Tạo bài viết AI từ chủ đề",
    description:
      "Dùng khi bạn cần tạo một bài nhanh từ ý tưởng ngắn. Bạn xem, sửa rồi tự chọn nơi đăng. Đây là công cụ tạo bài ngay, không phải automation chạy nhiều ngày.",
    steps: [
      {
        title: "Bước 1: Nhập ý tưởng",
        content:
          "Nhập chủ đề, thông báo, ưu đãi hoặc yêu cầu bạn muốn AI viết. Có thể thêm một URL để AI lấy ngữ cảnh, nhưng không nên đưa nhiều link trong một lần tạo.",
      },
      {
        title: "Bước 2: Chọn phong cách và nền tảng",
        content:
          "Chọn độ dài, giọng văn và nền tảng mục tiêu như Facebook hoặc Zalo. Nếu cần ảnh minh hoạ, bật tuỳ chọn tạo ảnh AI nếu tài khoản hỗ trợ.",
      },
      {
        title: "Bước 3: Tạo và kiểm tra nội dung",
        content:
          "Nhấn tạo nội dung, đọc lại bài, sửa các chi tiết như giá, số điện thoại, địa chỉ hoặc lời kêu gọi hành động.",
      },
      {
        title: "Bước 4: Chọn tài khoản và đăng",
        content:
          "Chọn Fanpage Facebook hoặc Zalo OA đã kết nối rồi đăng. Nếu chưa chọn tài khoản, nút đăng sẽ không hoạt động.",
      },
    ],
    features: [
      {
        name: "Nhanh cho bài lẻ",
        description:
          "Phù hợp khi bạn cần một bài ngay hôm nay, không cần tạo lịch tự động.",
      },
      {
        name: "Bạn luôn duyệt trước",
        description:
          "AI chỉ tạo bản nháp. Bạn quyết định sửa gì và đăng khi nào.",
      },
      {
        name: "Có thể dùng ảnh AI",
        description:
          "Nếu tài khoản hỗ trợ, bạn có thể tạo ảnh minh hoạ từ nội dung bài.",
      },
    ],
    tips: [
      "Đừng nhập quá chung chung. Ví dụ 'bài giảm giá váy hè 20%, khách nữ 25-35 tuổi' sẽ tốt hơn 'viết bài bán hàng'.",
      "Luôn kiểm tra số điện thoại, giá và địa chỉ trước khi đăng.",
    ],
    faqs: [
      {
        question: "Chức năng này có tự đăng hằng ngày không?",
        answer:
          "Không. Đây là công cụ tạo một bài ngay. Nếu muốn tự động chạy theo lịch, hãy dùng 'Tự động đăng từ chủ đề'.",
      },
    ],
    example: {
      scenario: "Cần đăng nhanh thông báo giảm giá cuối tuần.",
      input: "Giảm 20% toàn bộ váy hè, áp dụng thứ 7 và chủ nhật, freeship nội thành.",
      config: "Phong cách: thân thiện, ngắn gọn, có lời kêu gọi inbox.",
      result:
        "Bạn có một bài bán hàng hoàn chỉnh, sửa lại nếu cần rồi chọn Fanpage để đăng.",
    },
  },
  "photos-post": {
    title: "Tạo bài viết AI từ ảnh hoặc video",
    description:
      "Dùng khi bạn đã có ảnh/video và muốn AI nhìn nội dung đó để viết caption. Phù hợp cho ảnh sản phẩm, feedback khách hàng, ảnh sự kiện hoặc video ngắn.",
    steps: [
      {
        title: "Bước 1: Tải media lên",
        content:
          "Tải tối đa 9 ảnh hoặc 1 video upload. Không trộn ảnh và video trong cùng một lần tạo. Màn này hiện không hỗ trợ tạo bài từ video URL.",
        note:
          "Video upload thường yêu cầu gói Professional trở lên. Nếu tài khoản chưa đủ gói, hãy dùng ảnh hoặc nâng cấp trước.",
      },
      {
        title: "Bước 2: Nhập mô tả bổ sung",
        content:
          "Bạn có thể nhập thêm tên sản phẩm, giá, ưu đãi, địa chỉ hoặc điều muốn nhấn mạnh. Nếu để trống, AI sẽ dựa nhiều hơn vào ảnh/video.",
      },
      {
        title: "Bước 3: Chọn phong cách",
        content:
          "Chọn cách viết phù hợp: bán hàng, kể chuyện, chuyên nghiệp, gần gũi hoặc ngắn gọn. Với sản phẩm, nên ghi rõ đối tượng khách hàng.",
      },
      {
        title: "Bước 4: Kiểm tra và đăng",
        content:
          "AI tạo caption xong, bạn đọc lại, sửa thông tin quan trọng rồi chọn Fanpage/Zalo OA để đăng.",
      },
    ],
    features: [
      {
        name: "AI đọc nội dung trong ảnh/video",
        description:
          "AI có thể dựa vào hình ảnh để mô tả sản phẩm, bối cảnh hoặc điểm nổi bật.",
      },
      {
        name: "Tốt cho caption bán hàng",
        description:
          "Bạn chỉ cần đưa ảnh rõ và thông tin bổ sung, AI sẽ viết lời giới thiệu dễ đăng hơn.",
      },
      {
        name: "Kiểm soát trước khi đăng",
        description:
          "Bài được tạo ra để bạn duyệt và sửa, không tự đăng khi bạn chưa bấm đăng.",
      },
    ],
    tips: [
      "Ảnh quá tối, mờ hoặc bị che sản phẩm sẽ làm nội dung kém chính xác.",
      "Nếu ảnh có nhiều sản phẩm, hãy ghi rõ sản phẩm chính cần bán.",
    ],
    faqs: [
      {
        question: "Tôi có thể tải cả ảnh và video cùng lúc không?",
        answer:
          "Không nên và màn hình hiện giới hạn theo loại media. Hãy tạo riêng một bài ảnh hoặc một bài video.",
      },
      {
        question: "Vì sao tôi không upload được video?",
        answer:
          "Video upload thường cần gói Professional trở lên. Hãy kiểm tra gói hiện tại trong trang Gói dịch vụ.",
      },
    ],
    example: {
      scenario: "Đăng ảnh feedback khách mặc váy mới.",
      input: "3 ảnh khách mặc váy, ghi thêm: váy form A, 299k, còn màu trắng và xanh.",
      config: "Phong cách: gần gũi, bán hàng nhẹ nhàng.",
      result:
        "AI viết caption dựa trên ảnh thật, có thông tin giá và lời kêu gọi inbox.",
    },
  },
  "website-post": {
    title: "Tạo bài viết AI cho WordPress",
    description:
      "Dùng để tạo bài dài cho website WordPress. AutoWork hỗ trợ viết nội dung, gợi ý cấu trúc heading, meta, ảnh và xuất bản lên website đã kết nối.",
    steps: [
      {
        title: "Bước 1: Kiểm tra quyền dùng và kết nối WordPress",
        content:
          "Trước khi tạo bài, hãy vào 'Tài khoản' để kết nối WordPress. Tài khoản cũng cần đủ gói, lượt website miễn phí hoặc điểm theo thông báo trên màn hình.",
      },
      {
        title: "Bước 2: Chọn kiểu bài",
        content:
          "Bạn có thể tạo bài từ chủ đề/từ khoá, từ URL tham khảo, từ sản phẩm WooCommerce hoặc từ ảnh bạn tải lên. Chọn kiểu phù hợp với mục tiêu bài viết.",
      },
      {
        title: "Bước 3: Cài SEO và ảnh",
        content:
          "Chọn tiêu đề, từ khoá chính, danh mục, trạng thái đăng, ảnh minh hoạ và yêu cầu thêm cho AI. Nếu dùng ảnh AI, hệ thống có thể tính thêm điểm tuỳ cấu hình.",
      },
      {
        title: "Bước 4: Tạo bài và đọc lại",
        content:
          "AI tạo bản nháp để bạn xem trước. Hãy kiểm tra tiêu đề, đoạn mở đầu, heading, giá/sản phẩm, link, ảnh và thông tin liên hệ trước khi đăng.",
      },
      {
        title: "Bước 5: Đăng lên WordPress",
        content:
          "Khi nội dung đã đúng, nhấn đăng. Bài sẽ được gửi lên WordPress theo website, danh mục và trạng thái bạn đã chọn.",
      },
    ],
    features: [
      {
        name: "Tối ưu cho bài website",
        description:
          "Bài được viết dài hơn bài mạng xã hội, có cấu trúc heading và meta phù hợp để bạn tiếp tục tối ưu SEO.",
      },
      {
        name: "Hỗ trợ nhiều nguồn nội dung",
        description:
          "Có thể dùng chủ đề, URL, sản phẩm WooCommerce, ảnh upload hoặc ảnh AI tuỳ nhu cầu.",
      },
      {
        name: "Xuất bản trực tiếp lên WordPress",
        description:
          "Không cần copy thủ công nếu website đã kết nối đúng.",
      },
    ],
    tips: [
      "Không nên xem AI là SEO bảo đảm 100%. Hãy dùng AI để có bản nháp tốt, sau đó kiểm tra lại dữ kiện, liên kết nội bộ và ý định tìm kiếm.",
      "Nếu dùng Yoast hoặc plugin SEO, hãy kiểm tra lại điểm SEO trong WordPress sau khi đăng.",
      "Với bài sản phẩm, nên kiểm tra ảnh, giá và tình trạng còn hàng trước khi publish.",
    ],
    faqs: [
      {
        question: "Tôi cần gói nào để tạo bài website?",
        answer:
          "Màn hình sẽ kiểm tra gói, lượt website miễn phí và điểm còn lại. Nếu chưa đủ điều kiện, hệ thống sẽ báo trước khi tạo hoặc đăng.",
      },
      {
        question: "Bài có chắc chắn chuẩn SEO không?",
        answer:
          "Không nên hiểu là bảo đảm 100%. AutoWork giúp tối ưu cấu trúc, tiêu đề, meta, nội dung và ảnh; bạn vẫn nên đọc lại và chỉnh theo ngành hàng.",
      },
    ],
    example: {
      scenario: "Website bán đồ gia dụng muốn viết bài tư vấn chọn nồi chiên không dầu.",
      input: "Từ khoá: cách chọn nồi chiên không dầu cho gia đình 4 người.",
      config: "Danh mục: Kinh nghiệm mua sắm. Ảnh: lấy từ AI. Trạng thái: bản nháp.",
      result:
        "AutoWork tạo bài dài có heading rõ ràng, bạn duyệt lại rồi publish trên WordPress.",
    },
  },
  "classified-ad": {
    title: "Tạo tin rao vặt bằng AI",
    description:
      "Dùng khi bạn cần biến thông tin thô thành một tin rao dễ đọc, rõ giá trị và có lời kêu gọi liên hệ. Phù hợp cho bất động sản, xe cộ, tuyển dụng, dịch vụ hoặc sản phẩm cần rao nhanh.",
    steps: [
      {
        title: "Bước 1: Nhập thông tin thật đầy đủ",
        content:
          "Ghi rõ loại tin, giá, địa chỉ/khu vực, ưu điểm chính, tình trạng, số liên hệ và điều kiện giao dịch. Thông tin càng đủ, tin rao càng chính xác.",
      },
      {
        title: "Bước 2: Chọn phong cách tin",
        content:
          "Chọn cách viết phù hợp: gấp, chuyên nghiệp, thân thiện, nhấn mạnh giá tốt hoặc nhấn mạnh vị trí. Không nên phóng đại quá mức nếu thông tin chưa chắc chắn.",
      },
      {
        title: "Bước 3: Tạo và kiểm tra lại",
        content:
          "AI sẽ sắp xếp lại nội dung thành tin rao dễ đọc. Bạn cần kiểm tra kỹ giá, địa chỉ, diện tích, số điện thoại và điều kiện giao dịch trước khi đăng.",
      },
      {
        title: "Bước 4: Copy hoặc đăng theo kênh bạn chọn",
        content:
          "Sau khi có nội dung, bạn có thể copy sang nơi cần rao hoặc đăng qua các kênh mà tài khoản đã kết nối nếu màn hình hỗ trợ.",
      },
    ],
    features: [
      {
        name: "Biến thông tin thô thành tin dễ bán",
        description:
          "AI giúp sắp xếp lại điểm mạnh, giá trị và lời kêu gọi hành động.",
      },
      {
        name: "Giảm thiếu sót thông tin",
        description:
          "Guide nhắc bạn kiểm tra các chi tiết dễ sai như giá, khu vực, diện tích và số liên hệ.",
      },
    ],
    tips: [
      "Đừng chỉ nhập 'nhà đẹp giá tốt'. Hãy ghi rõ diện tích, vị trí, pháp lý, giá và điểm mạnh.",
      "Tin rao nên ngắn, rõ ý, có số liên hệ và tránh cam kết quá mức.",
    ],
    faqs: [
      {
        question: "Tin rao này khác bài viết AI thường ở đâu?",
        answer:
          "Tin rao tập trung vào thông tin giao dịch: giá, vị trí, lợi ích, điều kiện và liên hệ. Bài viết AI thường linh hoạt hơn cho nội dung fanpage.",
      },
    ],
    example: {
      scenario: "Môi giới cần đăng nhanh tin bán căn hộ.",
      input: "Căn 2PN, 68m2, Quận 7, giá 3.2 tỷ, view sông, sổ hồng, gần trường học.",
      config: "Phong cách: rõ ràng, nhấn mạnh vị trí và pháp lý.",
      result:
        "AI tạo tin rao có tiêu đề, gạch đầu dòng điểm mạnh và lời kêu gọi liên hệ.",
    },
  },
  "manage-automations": {
    title: "Quản lý automation sau khi đã lưu",
    description:
      "Sau khi tạo lịch tự động đăng, bạn cần biết nơi kiểm tra trạng thái, tạm dừng, sửa, xoá hoặc xử lý lỗi. Trang này giúp bạn không bị mất dấu các cấu hình đang chạy.",
    steps: [
      {
        title: "Bước 1: Vào đúng màn quản lý",
        content:
          "Mỗi loại automation có nơi quản lý riêng.\n• Tự động đăng từ chủ đề/website/WooCommerce: vào 'Quản lý tự động đăng'.\n• Đăng từ ảnh/video: vào 'Quản lý kho ảnh'.\n• Đăng từ bài viết có sẵn: vào 'Quản lý bài đăng thủ công'.\n• Đăng từ sản phẩm AutoWork: kiểm tra thêm trong 'Quản lý sản phẩm'.",
      },
      {
        title: "Bước 2: Đọc trạng thái cấu hình",
        content:
          "Các trạng thái thường gặp gồm đang chạy, tạm dừng, đang chờ, đã đăng, lỗi hoặc cần duyệt. Nếu có hàng chờ duyệt, bạn cần vào xem bài và bấm duyệt trước khi bài được đăng.",
      },
      {
        title: "Bước 3: Tạm dừng hoặc sửa khi cần",
        content:
          "Nếu chiến dịch hết khuyến mãi, sai lịch hoặc thiếu ảnh, hãy tạm dừng trước. Sau đó sửa nội dung, lịch, tài khoản đăng hoặc danh sách media rồi bật lại.",
      },
      {
        title: "Bước 4: Xử lý lỗi đăng bài",
        content:
          "Lỗi thường đến từ tài khoản mất kết nối, thiếu quyền Fanpage/Zalo/WordPress, thiếu điểm, ảnh/video không hợp lệ hoặc nội dung chưa được duyệt. Hãy đọc thông báo lỗi trên màn hình trước khi tạo cấu hình mới.",
      },
    ],
    features: [
      {
        name: "Không cần tạo lại từ đầu",
        description:
          "Nhiều lỗi có thể xử lý bằng cách sửa cấu hình hoặc thêm nội dung mới trong màn quản lý.",
      },
      {
        name: "Dễ kiểm soát bài đã đăng",
        description:
          "Bạn có thể biết nội dung nào đã chạy, nội dung nào đang chờ và cấu hình nào cần chú ý.",
      },
      {
        name: "Giảm rủi ro đăng sai",
        description:
          "Tạm dừng cấu hình trước khi sửa giúp tránh bài cũ tiếp tục lên sai lịch.",
      },
    ],
    tips: [
      "Nếu không chắc lỗi do đâu, hãy kiểm tra theo thứ tự: tài khoản kết nối, quyền đăng, điểm/gói, nội dung/media, lịch chạy.",
      "Không nên tạo nhiều cấu hình giống nhau cùng giờ cho cùng một tài khoản nếu bạn chưa cần, vì sẽ khó theo dõi lỗi.",
    ],
    faqs: [
      {
        question: "Tôi nên xoá hay tạm dừng cấu hình?",
        answer:
          "Nếu còn dùng lại sau này, hãy tạm dừng. Nếu cấu hình tạo sai hoàn toàn hoặc không cần nữa, mới nên xoá.",
      },
      {
        question: "Vì sao bài chưa đăng dù đã đến giờ?",
        answer:
          "Có thể cấu hình đang tạm dừng, bài đang chờ duyệt, thiếu quyền đăng, thiếu điểm hoặc hệ thống gặp lỗi từ nền tảng bên ngoài.",
      },
    ],
    example: {
      scenario: "Chiến dịch giảm giá kết thúc nhưng cấu hình vẫn còn lịch đăng.",
      input: "Vào màn quản lý tương ứng và tìm cấu hình giảm giá.",
      config: "Bấm tạm dừng, sửa nội dung hoặc xoá cấu hình nếu không dùng nữa.",
      result:
        "Không còn bài khuyến mãi cũ bị đăng nhầm sau khi chương trình kết thúc.",
    },
  },
  "facebook-comment-automation": {
    title: "Tự động trả lời bình luận và inbox",
    description:
      "Tính năng này chỉ dùng khi tài khoản của bạn được bật Facebook comment automation. Hệ thống có thể hỗ trợ trả lời bình luận, nhắn tin riêng, ẩn thông tin nhạy cảm và gửi thông báo để bạn không bỏ lỡ khách hàng.",
    steps: [
      {
        title: "Bước 1: Kiểm tra tài khoản có được bật tính năng",
        content:
          "Nếu bạn không thấy mục này trong menu chính, có thể tính năng chưa được bật cho tài khoản hoặc đang trong giai đoạn giới hạn. Hãy kiểm tra gói hiện tại hoặc liên hệ hỗ trợ.",
      },
      {
        title: "Bước 2: Chọn Fanpage và bài viết áp dụng",
        content:
          "Chọn Fanpage đã kết nối đủ quyền. Bạn có thể áp dụng cho nhiều bài viết hoặc một số bài cụ thể tuỳ màn hình cấu hình.",
      },
      {
        title: "Bước 3: Cung cấp kiến thức cho AI",
        content:
          "Nhập thông tin shop, bảng giá, chính sách giao hàng, câu hỏi thường gặp hoặc tải tài liệu nếu màn hình hỗ trợ. AI sẽ dựa vào đây để trả lời khách.",
      },
      {
        title: "Bước 4: Chọn hành động tự động",
        content:
          "Bật các hành động cần dùng như trả lời comment, nhắn tin riêng, ẩn số điện thoại/email hoặc gửi thông báo. Chỉ bật những hành động bạn đã hiểu rõ.",
      },
    ],
    features: [
      {
        name: "Giảm bỏ lỡ khách hàng",
        description:
          "Hệ thống hỗ trợ phản hồi khi bạn không trực fanpage liên tục.",
      },
      {
        name: "Ẩn thông tin nhạy cảm",
        description:
          "Có thể hỗ trợ ẩn số điện thoại hoặc email trong bình luận nếu cấu hình bật.",
      },
      {
        name: "Phụ thuộc quyền Facebook",
        description:
          "Fanpage cần cấp đúng quyền để hệ thống đọc bình luận và phản hồi.",
      },
    ],
    tips: [
      "Kiến thức càng rõ, AI trả lời càng đúng. Hãy ghi giá, chính sách đổi trả, phí ship và giờ làm việc.",
      "Không nên bật trả lời tự động cho mọi bài nếu bạn chưa kiểm thử với vài bài quan trọng trước.",
    ],
    faqs: [
      {
        question: "Vì sao tôi không thấy chức năng này trong menu?",
        answer:
          "Tính năng có thể đang ẩn hoặc chỉ bật cho một số tài khoản/gói. Hãy kiểm tra gói hoặc liên hệ hỗ trợ.",
      },
    ],
    example: {
      scenario: "Shop chạy quảng cáo ban đêm và muốn không bỏ sót khách hỏi giá.",
      input: "Nhập bảng giá, phí ship và chính sách đổi trả vào kiến thức AI.",
      config: "Bật trả lời comment và nhắn tin riêng cho bài quảng cáo đang chạy.",
      result:
        "Khách được phản hồi nhanh hơn, còn chủ shop vẫn có thể kiểm tra lại lịch sử sau đó.",
    },
  },
  "video-creator": {
    title: "Trình tạo video AI",
    description:
      "Dùng để biến ảnh sản phẩm và nội dung bán hàng thành video ngắn có kịch bản, giọng đọc, phụ đề và định dạng phù hợp mạng xã hội. Phù hợp khi bạn cần video quảng cáo nhanh từ ảnh có sẵn.",
    steps: [
      {
        title: "Bước 1: Chọn chế độ tạo video",
        content:
          "Có hai cách dùng.\n• Chế độ nhanh: tải ảnh, nhập thông tin, để hệ thống tạo video theo flow đơn giản.\n• Chế độ nâng cao: tự chỉnh kịch bản, giọng đọc, format và preview kỹ hơn trước khi xuất.",
      },
      {
        title: "Bước 2: Tải ảnh và nhập thông tin",
        content:
          "Tải tối đa 10 ảnh trong chế độ nhanh. Nên dùng ảnh rõ sản phẩm, đúng thứ tự bạn muốn kể chuyện. Nhập tên sản phẩm, lợi ích, giá hoặc ưu đãi để AI viết kịch bản sát hơn.",
      },
      {
        title: "Bước 3: Tạo kịch bản và giọng đọc",
        content:
          "AI tạo kịch bản video, sau đó bạn có thể chọn giọng đọc và định dạng. Hãy kiểm tra lại câu chữ, giá, số điện thoại và lời kêu gọi hành động.",
      },
      {
        title: "Bước 4: Xem trước và xuất video",
        content:
          "Xem preview trước khi xuất. Khi đã ổn, xuất video để tải về. Theo code hiện tại, file tải về dùng định dạng WebM.",
      },
    ],
    features: [
      {
        name: "Có chế độ nhanh và nâng cao",
        description:
          "Người mới có thể dùng nhanh, người cần kiểm soát có thể chỉnh sâu hơn.",
      },
      {
        name: "Tạo kịch bản và giọng đọc",
        description:
          "AI hỗ trợ biến thông tin sản phẩm thành lời thoại video dễ nghe hơn.",
      },
      {
        name: "Phù hợp video ngắn",
        description:
          "Dùng tốt cho video quảng cáo, giới thiệu sản phẩm hoặc nội dung mạng xã hội.",
      },
    ],
    tips: [
      "Ảnh đầu tiên nên là ảnh rõ nhất vì thường tạo ấn tượng mở đầu.",
      "Giữ video ngắn, thông điệp rõ và nhắc ưu đãi sớm trong kịch bản.",
      "Nếu cần nhạc nền, hãy kiểm tra UI hiện tại của tài khoản. Guide này chỉ ghi nhận các control đang thấy trong code: ảnh, kịch bản, giọng đọc, format, preview và export.",
    ],
    faqs: [
      {
        question: "Tôi có thể xuất file gì?",
        answer:
          "Theo code hiện tại, video được tải về dưới dạng WebM. Nếu cần định dạng khác, hãy kiểm tra nút export trong màn hình thực tế hoặc chuyển đổi sau khi tải.",
      },
    ],
    example: {
      scenario: "Shop muốn tạo video ngắn cho sản phẩm serum mới.",
      input: "8 ảnh sản phẩm, thông tin: serum sáng da, 299k, freeship, phù hợp da xỉn màu.",
      config: "Chế độ nhanh, format dọc, giọng đọc nữ, kịch bản bán hàng ngắn.",
      result:
        "Có video giới thiệu sản phẩm để tải về và đăng lên kênh phù hợp.",
    },
  },
  "lead-engine": {
    title: "Quản lý khách tiềm năng",
    description:
      "Tính năng này chỉ dùng khi tài khoản được bật Lead Engine. Mục tiêu là gom thông tin khách quan tâm từ các tương tác để bạn theo dõi và chăm sóc tốt hơn.",
    steps: [
      {
        title: "Bước 1: Kiểm tra tính năng đã được bật",
        content:
          "Nếu bạn không thấy Lead Engine trong menu, có thể tính năng đang ẩn hoặc chỉ mở cho một số tài khoản. Hãy kiểm tra gói hoặc liên hệ hỗ trợ.",
      },
      {
        title: "Bước 2: Kết nối nguồn tương tác",
        content:
          "Lead Engine thường đi cùng các nguồn như bình luận, inbox hoặc chiến dịch chăm sóc khách. Cần đảm bảo các kênh liên quan đã kết nối đúng quyền.",
      },
      {
        title: "Bước 3: Theo dõi khách theo trạng thái",
        content:
          "Khách có thể được phân loại theo trạng thái như mới, đang tư vấn hoặc đã chuyển đổi. Hãy dùng trạng thái để biết ai cần chăm sóc tiếp.",
      },
      {
        title: "Bước 4: Xem báo cáo và hành động",
        content:
          "Dùng dashboard để xem chiến dịch nào tạo ra nhiều khách quan tâm, sau đó ưu tiên chăm sóc nhóm có khả năng mua cao.",
      },
    ],
    features: [
      {
        name: "Theo dõi khách có nhu cầu",
        description:
          "Giúp bạn không để khách quan tâm bị trôi trong comment hoặc inbox.",
      },
      {
        name: "Phân loại để chăm sóc",
        description:
          "Trạng thái khách giúp đội sale biết ai cần gọi lại hoặc nhắn tiếp.",
      },
    ],
    tips: [
      "Mỗi ngày nên kiểm tra nhóm khách đang tư vấn để chuyển cho người phụ trách chốt đơn.",
      "Nếu chưa bật tự động bình luận/inbox, Lead Engine có thể chưa có đủ dữ liệu.",
    ],
    faqs: [
      {
        question: "Vì sao tôi không thấy Lead Engine?",
        answer:
          "Tính năng đang bị ẩn khỏi menu chính trong giao diện hiện tại hoặc chưa bật cho tài khoản của bạn.",
      },
    ],
    example: {
      scenario: "Fanpage chạy quảng cáo và có nhiều khách hỏi giá.",
      input: "Kết nối nguồn bình luận/inbox và bật tính năng theo dõi lead nếu tài khoản hỗ trợ.",
      config: "Theo dõi khách mới và khách đang tư vấn mỗi ngày.",
      result:
        "Đội sale có danh sách khách cần chăm sóc thay vì tìm thủ công trong từng bài viết.",
    },
  },
  "affiliate": {
    title: "Tiếp thị liên kết Affiliate",
    description:
      "Dùng khi bạn muốn giới thiệu AutoWork cho người khác và theo dõi hoa hồng từ link giới thiệu của mình. Phù hợp cho người làm cộng đồng, agency, đào tạo hoặc người có tệp khách cần tự động hoá nội dung.",
    steps: [
      {
        title: "Bước 1: Mở trang Affiliate",
        content:
          "Vào mục Affiliate trong menu. Nếu tài khoản cần kích hoạt thêm, hãy làm theo hướng dẫn trên màn hình hoặc liên hệ hỗ trợ.",
      },
      {
        title: "Bước 2: Lấy link giới thiệu",
        content:
          "Sao chép link giới thiệu cá nhân. Gửi link này cho khách, bạn bè hoặc cộng đồng của bạn. Nên giải thích rõ AutoWork giúp họ làm gì để tăng tỷ lệ đăng ký.",
      },
      {
        title: "Bước 3: Tạo chiến dịch riêng nếu cần",
        content:
          "Nếu bạn chia sẻ ở nhiều nơi, hãy tạo các link chiến dịch khác nhau để biết nguồn nào hiệu quả hơn.",
      },
      {
        title: "Bước 4: Theo dõi thống kê và giao dịch",
        content:
          "Dùng các tab thống kê, giao dịch và chiến dịch để xem click, đăng ký, thanh toán và hoa hồng theo trạng thái hiển thị trong app.",
      },
    ],
    features: [
      {
        name: "Có link giới thiệu cá nhân",
        description:
          "Hệ thống dùng link để ghi nhận người dùng mới đến từ bạn.",
      },
      {
        name: "Theo dõi theo chiến dịch",
        description:
          "Bạn có thể tạo nhiều link để đo hiệu quả từng kênh chia sẻ.",
      },
      {
        name: "Giao dịch có trạng thái",
        description:
          "Hoa hồng phụ thuộc vào giao dịch thật và trạng thái thanh toán trong hệ thống.",
      },
    ],
    tips: [
      "Đừng chỉ gửi link. Hãy kèm ví dụ cụ thể: AutoWork giúp shop đăng bài, tạo ảnh/video, viết bài website hoặc tự động hoá fanpage.",
      "Nếu chạy quảng cáo, nên tạo link chiến dịch riêng cho từng kênh để dễ đo hiệu quả.",
    ],
    faqs: [
      {
        question: "Khi nào hoa hồng được ghi nhận?",
        answer:
          "Hoa hồng được ghi nhận theo quy tắc affiliate hiện hành khi người được giới thiệu phát sinh giao dịch hợp lệ.",
      },
      {
        question: "Tôi xem tiền ở đâu?",
        answer:
          "Vào tab giao dịch hoặc thống kê trong trang Affiliate để xem trạng thái từng khoản hoa hồng.",
      },
    ],
    example: {
      scenario: "Một agency giới thiệu AutoWork cho khách đang cần đăng bài đa kênh.",
      input: "Gửi link giới thiệu kèm hướng dẫn dùng thử tạo bài AI và auto-post.",
      config: "Tạo chiến dịch riêng cho nhóm khách agency.",
      result:
        "Agency theo dõi được khách nào đăng ký và giao dịch nào tạo hoa hồng.",
    },
  },
};

export const startHereGuide = guideContents["start-here"];
export const autoPostGuide = guideContents["auto-post"];
export const addListImagesGuide = guideContents["add-list-images"];
export const productAutoPostGuide = guideContents["product-auto-post"];
export const manualPostGuide = guideContents["manual-post"];
export const normalPostGuide = guideContents["normal-post"];
export const photosPostGuide = guideContents["photos-post"];
export const websitePostGuide = guideContents["website-post"];
export const classifiedAdGuide = guideContents["classified-ad"];
export const manageAutomationsGuide = guideContents["manage-automations"];
export const facebookCommentGuide = guideContents["facebook-comment-automation"];
export const videoCreatorGuide = guideContents["video-creator"];
export const leadEngineGuide = guideContents["lead-engine"];
export const affiliateGuide = guideContents["affiliate"];
